export const getCsrfToken = (): string => {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
};

export const getInitials = (user: { firstname?: string; lastname?: string }): string => {
    const first = user.firstname?.[0] ?? '';
    const last = user.lastname?.[0] ?? '';
    return `${first}${last}`.toUpperCase() || '?';
};

export const formatTime = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};
